import { ChatListProps } from "./types"
import React, { useCallback, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { FlatList } from "~widgets/flat-list"
// import Seperator from "./components/seperator"
import ChatListItem from "./components/chat-list-item"
import NoData from "~components/Layout/components/NoData"

const ChatList: React.FC<ChatListProps> = ({
  data,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  const keyExtractor = useCallback((item, idx) => item.chat_id || idx.toString(), [])
  const sortedData = useMemo(() => {
    const toMs = (value: unknown) => {
      if (value instanceof Date) return value.valueOf()
      if (typeof value === "number") return Number.isFinite(value) ? value : 0
      if (typeof value === "string") {
        const n = Date.parse(value)
        return Number.isNaN(n) ? 0 : n
      }
      return 0
    }

    const getChatTime = (item: any) =>
      toMs(item?.lastMessage?.created) || toMs(item?.updated) || toMs(item?.created)

    const list = Array.isArray(data) ? data : []
    return [...list].sort((a: any, b: any) => getChatTime(b) - getChatTime(a))
  }, [data])
  // const ItemSeparatorComponent = useCallback(() => <Seperator />, [])
  return (
    <FlatList
      data={sortedData}
      swipeActionButtonConfigs={swipeActionButtonConfigs}
      selecteds={selecteds}
      keyExtractor={keyExtractor}
      ItemSeparatorComponent={null}
      renderItem={({ item, selecteds }) => {
        return (
          <ChatListItem item={item} selecteds={selecteds} onItemClick={onItemClick} />
        )
      }}
      ListEmptyComponent={<NoData title="未找到好友" content="您还没聊天好友, 快去添加吧!" ></NoData>}
    />

  )
}

export default observer(ChatList)
